import * as THREE from 'three';
import { MeshNormalNodeMaterial } from 'three/webgpu';

import { EngineClass } from '../../../systems/ClassRegistry.js';
import { property } from '../../../utils/serialization/decorator.js';

import { NodeMaterialAsset } from './NodeMaterialAsset.js';

import type { TexturePath } from '../../../utils/serialization/decorator.js';
import type { IDumper, ILoader } from '../../../utils/serialization/factories.js';

/** WebGPU `MeshNormalNodeMaterial` asset: debug/viewport visualization of mesh normals. */
@EngineClass('MeshNormalNodeMaterialAsset', {
  isNodeMaterialAsset: true,
  nodeMaterialDisplayName: 'Mesh Normal Node Material',
  nodeMaterialGroup: 'TSL Node (THREE)',
})
export class MeshNormalNodeMaterialAsset extends NodeMaterialAsset(MeshNormalNodeMaterial) {

  @property({ type: 'boolean', description: 'Enable flat shading' })
  override flatShading = false;

  @property({ type: 'texturePath', description: 'Bump map path' })
    bumpMapPath: TexturePath = '';

  @property({ type: 'texturePath', description: 'Normal map path' })
    normalMapPath: TexturePath = '';

  @property({ type: 'texturePath', description: 'Displacement map path' })
    displacementMapPath: TexturePath = '';

  constructor() {
    super();
    this.rebuild();
  }

  override rebuild(): void {
    this.applyCommonMaterialState();
    this.syncTexturePath('bumpMap', this.bumpMapPath, THREE.NoColorSpace);
    this.syncTexturePath('normalMap', this.normalMapPath, THREE.NoColorSpace);
    this.syncTexturePath('displacementMap', this.displacementMapPath, THREE.NoColorSpace);
    // Normal vectors from geometry are used automatically — no authored params.
  }

  public serialize(dumper: IDumper): void {
    this.serializeAuthoredFields(dumper);
  }

  public static staticDeserialize(data: unknown, loader: ILoader): MeshNormalNodeMaterialAsset {
    const instance = new MeshNormalNodeMaterialAsset();
    MeshNormalNodeMaterialAsset.loadAuthoredFields(instance, loader);
    instance.rebuild();
    return instance;
  }
}
